import loadable from "@loadable/component";

export const ShowcasePage = loadable(() => import("./ShowcasePage"), {
  resolveComponent: mod => mod.ShowcasePage,
});

export * from "./types";
